import React from 'react';
import { withTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import moment from 'moment'; // moment

const useStyles = makeStyles({
    mainDiv:{
        width:'calc(100% - 20px)',
        display:'flex',
        flexDirection:'column',
        borderRadius:'5px',
        backgroundColor:'#fff',
        padding:'0px 10px 25px 10px',
        marginBottom:'30px',
        boxShadow:'0px 1px 2px #00000038'
    },

    marRight:{
        marginRight:'10px',
    },
    marLeft:{
        marginLeft:'10px',
    },

    header:{
        fontSize:'20px',
        marginTop:'20px',
        color:'#000',
        fontWeight:'bold',
        textTransform:'capitalize',
        textAlign:'center',
        maxWidth: '90%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },

    listDiv:{
        width:'calc(100% - 20px)',
        display:'flex',
        flexDirection:'row',
        padding:'4px 10px'
    },

    timeDiv:{
        display:'flex',
        flexDirection:'row',
        width:'50%'
    },

    dayName:{
        width:"150px",
        fontSize:'14px',
        color:'#0F467A',
        fontWeight:'bold',
        textTransform:'capitalize'
    },

    marRight_20:{
        marginRight:'20px'
    },
    marLeft_20:{
        marginLeft:'20px'
    },

    timeSpan:{
        color:'#343434',
        width:'60px'
    },

    closeSpan:{
        color:'#DE001E',
        width:'60px',
        textAlign:'center'
    }
});

function WorkingHour(props) {    
    const { t, i18n, workingHour, fontDarkColor } = props;

    const checkTime = (startDate,endDate) => {// this function return true if startDate and endDate are same
        return (moment(new Date(startDate*1000)).format('hh:mm') === '12:00' && moment(new Date(endDate*1000)).format('hh:mm') === '12:00') || moment(new Date(startDate*1000)).format('hh:mm') === moment(new Date(endDate*1000)).format('hh:mm')
    }

    const classes = useStyles({fontDarkColor});
    const isRTL = i18n.translator.language;
    moment.locale(isRTL);
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en;
    return(
        <div className={classes.mainDiv}>
            <span className={classes.header} style={{fontFamily,textAlign:isRTL === 'ar' ? 'right' : 'left'}}>{t('companyPage.working')}</span>
            
            <div className={classes.listDiv}>
                <span style={{fontFamily}} className={`${classes.dayName} ${isRTL === 'ar' ? classes.marLeft_20 : classes.marRight_20}`}>{t('comp-comp.sunday')}</span>
                <div className={classes.timeDiv}>
                {checkTime(workingHour.sundayStartTime,workingHour.sundayEndTime) ?
                    <span className={classes.closeSpan} style={{fontFamily}}>{t('companyPage.closed')}</span>
                :
                    <>
                        <span style={{fontFamily}} className={`${classes.timeSpan} ${isRTL === 'ar' ? classes.marLeft_20 : classes.marRight_20}`}>{moment(new Date(workingHour.sundayStartTime*1000)).format('hh:mm')}</span>
                        <span className={classes.timeSpan} style={{fontFamily}}>{moment(new Date(workingHour.sundayEndTime*1000)).format('hh:mm')}</span>
                    </>
                }
                </div>
            </div>

            <div className={classes.listDiv}>
                <span style={{fontFamily}} className={`${classes.dayName} ${isRTL === 'ar' ? classes.marLeft_20 : classes.marRight_20}`}>{t('comp-comp.monday')}</span>
                <div className={classes.timeDiv}>
                {checkTime(workingHour.mondayStartTime,workingHour.mondayEndTime) ?
                    <span className={classes.closeSpan} style={{fontFamily}}>{t('companyPage.closed')}</span>
                :
                    <>
                        <span style={{fontFamily}} className={`${classes.timeSpan} ${isRTL === 'ar' ? classes.marLeft_20 : classes.marRight_20}`}>{moment(new Date(workingHour.mondayStartTime*1000)).format('hh:mm')}</span>
                        <span className={classes.timeSpan} style={{fontFamily}}>{moment(new Date(workingHour.mondayEndTime*1000)).format('hh:mm')}</span>
                    </>
                }
                </div>
            </div>

            <div className={classes.listDiv}>
                <span style={{fontFamily}} className={`${classes.dayName} ${isRTL === 'ar' ? classes.marLeft_20 : classes.marRight_20}`}>{t('comp-comp.tuesday')}</span>
                <div className={classes.timeDiv}>
                {checkTime(workingHour.tuesdayStartTime,workingHour.tuesdayEndTime) ?
                    <span className={classes.closeSpan} style={{fontFamily}}>{t('companyPage.closed')}</span>
                :
                    <>
                        <span style={{fontFamily}} className={`${classes.timeSpan} ${isRTL === 'ar' ? classes.marLeft_20 : classes.marRight_20}`}>{moment(new Date(workingHour.tuesdayStartTime*1000)).format('hh:mm')}</span>
                        <span className={classes.timeSpan} style={{fontFamily}}>{moment(new Date(workingHour.tuesdayEndTime*1000)).format('hh:mm')}</span>
                    </>
                }
                </div>
            </div>

            <div className={classes.listDiv}>
                <span style={{fontFamily}} className={`${classes.dayName} ${isRTL === 'ar' ? classes.marLeft_20 : classes.marRight_20}`}>{t('comp-comp.wednesday')}</span>
                <div className={classes.timeDiv}>
                {checkTime(workingHour.wednesdayStartTime,workingHour.wednesdayEndTime) ?
                    <span className={classes.closeSpan} style={{fontFamily}}>{t('companyPage.closed')}</span>
                :
                    <>
                        <span style={{fontFamily}} className={`${classes.timeSpan} ${isRTL === 'ar' ? classes.marLeft_20 : classes.marRight_20}`}>{moment(new Date(workingHour.wednesdayStartTime*1000)).format('hh:mm')}</span>
                        <span className={classes.timeSpan} style={{fontFamily}}>{moment(new Date(workingHour.wednesdayEndTime*1000)).format('hh:mm')}</span>
                    </>
                }
                </div>
            </div>

            <div className={classes.listDiv}>
                <span style={{fontFamily}} className={`${classes.dayName} ${isRTL === 'ar' ? classes.marLeft_20 : classes.marRight_20}`}>{t('comp-comp.thursday')}</span>
                <div className={classes.timeDiv}>
                {checkTime(workingHour.thursdayStartTime,workingHour.thursdayEndTime) ?
                    <span className={classes.closeSpan} style={{fontFamily}}>{t('companyPage.closed')}</span>
                :
                    <>
                        <span style={{fontFamily}} className={`${classes.timeSpan} ${isRTL === 'ar' ? classes.marLeft_20 : classes.marRight_20}`}>{moment(new Date(workingHour.thursdayStartTime*1000)).format('hh:mm')}</span>
                        <span className={classes.timeSpan} style={{fontFamily}}>{moment(new Date(workingHour.thursdayEndTime*1000)).format('hh:mm')}</span>
                    </>
                }
                </div>
            </div>

            <div className={classes.listDiv}>
                <span style={{fontFamily}} className={`${classes.dayName} ${isRTL === 'ar' ? classes.marLeft_20 : classes.marRight_20}`}>{t('comp-comp.friday')}</span>
                <div className={classes.timeDiv}>
                {checkTime(workingHour.fridayStartTime,workingHour.fridayEndTime) ?
                    <span className={classes.closeSpan} style={{fontFamily}}>{t('companyPage.closed')}</span>
                :
                    <>
                        <span style={{fontFamily}} className={`${classes.timeSpan} ${isRTL === 'ar' ? classes.marLeft_20 : classes.marRight_20}`}>{moment(new Date(workingHour.fridayStartTime*1000)).format('hh:mm')}</span>
                        <span className={classes.timeSpan} style={{fontFamily}}>{moment(new Date(workingHour.fridayEndTime*1000)).format('hh:mm')}</span>
                    </>
                }
                </div>
            </div>

            <div className={classes.listDiv}>
                <span style={{fontFamily}} className={`${classes.dayName} ${isRTL === 'ar' ? classes.marLeft_20 : classes.marRight_20}`}>{t('comp-comp.saturday')}</span>
                <div className={classes.timeDiv}>
                {checkTime(workingHour.saturdayStartTime,workingHour.saturdayEndTime) ?
                    <span className={classes.closeSpan} style={{fontFamily}}>{t('companyPage.closed')}</span>
                :
                    <>
                        <span style={{fontFamily}} className={`${classes.timeSpan} ${isRTL === 'ar' ? classes.marLeft_20 : classes.marRight_20}`}>{moment(new Date(workingHour.saturdayStartTime*1000)).format('hh:mm')}</span>
                        <span className={classes.timeSpan} style={{fontFamily}}>{moment(new Date(workingHour.saturdayEndTime*1000)).format('hh:mm')}</span>
                    </>
                }
                </div>
            </div>

        </div>
    )
}

export default withTranslation('common')(WorkingHour);